import { render, staticRenderFns } from "./RekycDashboard.vue?vue&type=template&id=8f45f750&"
import script from "./RekycDashboard.vue?vue&type=script&lang=js&"
export * from "./RekycDashboard.vue?vue&type=script&lang=js&"
import style0 from "./RekycDashboard.vue?vue&type=style&index=0&id=8f45f750&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports